import constants from "../../../constants";
import AlertContext from "../../../context/AlertContext";
import { SandpackFileExplorer } from "sandpack-file-explorer";
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../Notification-Loading/Loading/Loading";
import SandPackEditorHooks from "../../../Hooks/SandPackEditorHooks";
import HeaderHooks from "../Header/Hooks/HeaderHooks";

const styles = {
  div: {
    zIndex: 2,
    top: "18px",
    right: "50px",
    position: "absolute",
    transform: "translate(-0px, -0px)",
  },
  svg: {
    right: "0px",
    width: "14px",
    height: "14px",
    position: "absolute",
  },
  div2: {
    position: "relative",
  },
  input: {
    zIndex: 2,
    opacity: 0,
    left: "-15px",
    width: "14px",
    height: "14px",
    position: "absolute",
  },
};

export default function CustomFileExplorer({ sandpack ,filesLoaded}) {
  const Alert = useContext(AlertContext);

  const SandPackEditorHks = SandPackEditorHooks();
  const HeaderHks = HeaderHooks();

  let [hasred, sethadred] = useState(false);

  useEffect(() => {
    if (!hasred) {
      setTimeout(() => {
        sethadred(true);
      }, 2000);
    }
  }, [hasred]);

  const handleBackWarning = () => {
    console.log("handleBackWarning");
    console.log(
      "Alert?.contenData?.switchedcount",
      Alert?.contenData?.switchedcount
    );
    if (Alert.contentData?.switchedcount <= 10) {
      Alert.setShowNotify({
        show: true,
        title: "Warning",
        primaryButton: "Cancel",
        secondaryButton: "Go Back",
        secondaryButtonFunction: () =>
          SandPackEditorHks.closeAssignment("back"),
        msg: `Are you sure, you want to go back. If you are going back you will lose one attempt.`,
      });
    } else {
      SandPackEditorHks.handleBack();
    }
  };

  const handlePractiseTestSubmit = async () => {
    console.log("handlePractiseTestSubmit");

    // if (Alert.contentData?.switchedcount < 10) {
    // Alert.setShowNotify({
    //   show: true,
    //   title: "Warning",
    //   primaryButton: "Cancel",
    //   secondaryButton: "Submit & Exit",
    //   secondaryButtonFunction: () => {
    //     SandPackEditorHks.closeAssignment("back");
    //   },
    //   msg: `Are you sure, you want to go back. You didn't save your progress.`,
    // });
    await HeaderHks.handleSubmitAssignmentOnSandpack(false)
      .then((res) => SandPackEditorHks.handleBack())
      .catch((error) =>
        Alert.setShowNotify({
          show: true,
          msg: "Unable to save your progress. Please try again or contact gradious team.",
          title: "Warning !",
          primaryButton: "Ok",
          primaryButtonFunction: () => SandPackEditorHks.handleBack(),
        })
      );
    // } else {
    //   SandPackEditorHks.handleBack();
    // }
  };

  // console.log("Alert.contentData", Alert.contentData);
  // console.log("Sandpack:",sandpack?.files);
  // console.log("sandpack:",sandpack);
  

  const onUploadFile = (event) => {
    const reader = new FileReader();
    const fileName = event.target.files[0].name;

    // reader.onload = (e) => {
    //   sandpack.addFile({
    //     ...sandpack.files,
    //     [`/${fileName}`]: { code: e.target.result },
    //   });

    //   sethadred(false);
    // };
    reader.onload = (e) => {
      const newFile = {
        [`/${fileName}`]: { code: e.target.result },
      };

      sandpack.addFile({
        ...newFile,
        ...sandpack.files,
      });

      sethadred(false);
    };
    reader.readAsDataURL(event.target.files[0]);
    event.target.value = "";
  };

  return (
    <div className="fileexplorercontainer" style={{ background: "#151515" }}>
      <div className="backfromsandpack" title="back">
        <svg
          width="18"
          height="18"
          fill="none"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
          onClick={
            Alert.testData.proctored === constants.PROCTORING_MODE.NONE &&
            Alert.status !== constants.PROGRESS_STATUS.EVALUATED &&
            Alert.status !== constants.PROGRESS_STATUS.PARTIAL_EVALUATED
              ? handlePractiseTestSubmit //Practise test so can able to submit and save test as long as it is not evaluated and due date is there..
              : Alert.isAdmin ||
                Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
                Alert.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED ||
                Alert.showBreadCrumbsData.from === "learner"
              ? SandPackEditorHks.handleBack //No submit and save button as It is evaluated..
              : handleBackWarning
          }
        >
          <path
            stroke-width="2"
            stroke="#EAECF0"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.25 13.5L6.75 9L11.25 4.5"
          />
        </svg>
      </div>

      <div
        className="fileExplorercustomsandpack"
        style={{ background: "#151515", position: "relative" }}
      >
        {filesLoaded && hasred ? (
          <>
            <div style={styles.div}>
              <div style={{ position: "relative" }}>
                <svg
                  width="14"
                  height="14"
                  fill="none"
                  style={styles.svg}
                  viewBox="0 0 24 24"
                  className="sandpackUploadIcon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeWidth="2"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
                  />
                </svg>
                <input
                  type="file"
                  accept="image/*"
                  style={styles.input}
                  onChange={onUploadFile}
                />
              </div>
            </div>

            <SandpackFileExplorer />
          </>
        ) : (
          <div className="loadinfileexp">
            <Loading />
          </div>
        )}
      </div>
    </div>
  );
}
